/**
 * Converts a hex color code to an RGB or RGBA string.
 * @param {string} hex - The hex color code, e.g., "#FFFFFF" or "FFFFFF".
 * @param {number} [alpha] - Optional alpha value (0 to 1) for RGBA format.
 * @returns {string} A string in the format "rgb(r, g, b)" or "rgba(r, g, b, a)".
 * Defaults to black if input is invalid.
 */
function hexToRgba(hex, alpha) {
  // Check if hex is undefined or null
  if (!hex) {
    // Default to black if no color provided
    return 'rgb(0, 0, 0)';
  }

  // Remove the hash if present and create a new string
  const cleanHex = hex.replace(/^#/, '');

  // Validate the input
  if (cleanHex.length !== 3 && cleanHex.length !== 6) {
    // Default to black if invalid format
    return 'rgb(0, 0, 0)';
  }

  // If shorthand (3 characters), expand to 6 characters
  const fullHex = cleanHex.length === 3
    ? cleanHex.split('').map((char) => char + char).join('')
    : cleanHex;

  // Convert the hex values to decimal
  const r = parseInt(fullHex.slice(0, 2), 16);
  const g = parseInt(fullHex.slice(2, 4), 16);
  const b = parseInt(fullHex.slice(4, 6), 16);

  // Check if any value is NaN (invalid hex code)
  if (Number.isNaN(r) || Number.isNaN(g) || Number.isNaN(b)) {
    // Default to black if conversion fails
    return 'rgb(0, 0, 0)';
  }

  // Return RGB or RGBA format
  if (alpha !== undefined) {
    if (alpha < 0 || alpha > 1) {
      // Use RGB if alpha is invalid
      return `rgb(${r}, ${g}, ${b})`;
    }
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  }

  return `rgb(${r}, ${g}, ${b})`;
}

export default hexToRgba;
